<template lang="pug">
.container-dimensions(v-if="src")
  .image-dimension-container(@mousemove.prevent="moveText" @mouseleave="clearTextSize" ref="$TextContainer")
    img.image-dimension(ref="$Image" :src="src" @load="imageLoaded=true")
    canvas(ref="$Canvas" id="$Canvas" v-if="false")
    .size-dimension.left(v-for="(t, indexText) in objects.texts" :style="`color: ${t.color}; left: ${t.left}%; top: ${t.top}%; font-size: ${convertSizeFont(t.size)}px; transform: rotateZ(${t.degrees}deg)`" @mousedown.prevent="setTextSize(indexText)" @mouseup.prevent="clearTextSize" :class="{'cursor-move': text.move, 'cursor-edit': text.edit, 'cursor-eraser': eraser.active}")
      .size-item-dimension(v-for="(size, indexSize) in t.sizes")
        span.no-wrap.dark {{ size }}
        span(:class="{hidden: !size}") -
        span.no-wrap {{ t.values[indexSize] }}
  .toolbar
    .container-pen(v-if="!eraser.active && !text.active && !text.move && !text.edit && false")
      .container-icon-dimension(@click="togglePath" :class="{active: creating.path}")
        img(:src="require('@/assets/pen.png')" alt="lapiz")
      input.input-color(v-if="!pen.active" type="color" v-model="configLines.stroke")
      // input.input-color.radiance(v-if="!pen.active" type="color" v-model="configLines.shadow.color")
      .container-icon-dimension(v-if="!pen.active" @click="togglePoints" :class="{active: points.hide}")
        img(:src="require('@/assets/hide-points.png')" alt="points")

    .container-eraser(v-if="!pen.active && !text.active && !text.move && !text.edit")
      .container-icon-dimension(@click="toggleEraser" :class="{active: eraser.active}")
        img(:src="require('@/assets/eraser.png')" alt="borrador")

    .container-text(v-if="!pen.active && !eraser.active")
      .container-icon-dimension(v-if="!text.move && !text.edit" @click="openSizeText" :class="{active: text.active}")
        img(:src="require('@/assets/text.png')" alt="texto")
      .container-icon-dimension(v-if="!text.active && !text.edit" @click="toggleMoveSizeText" :class="{active: text.move}")
        img(:src="require('@/assets/move.png')" alt="move")
      .container-icon-dimension(v-if="!text.active && !text.move" @click="toggleEditSizeText" :class="{active: text.edit}")
        img(:src="require('@/assets/edit.png')" alt="edit")

    div(v-if="!scriptLoaded && false") Cargando

  shSizeText(v-if="showSizeText" @close="closeSizeText" @save="addSizes" @update="updateSizes" :sizesEdit="objects.sizesText" :valuesEdit="objects.valuesText" :index="objects.currentIndex" :colorEdit="objects.colorText" :sizeEdit="objects.sizeText" :degreesEdit="objects.degreesText")
</template>

<script>
import shSizeText from '@/components/elements/dimensions/SizeText.vue'

export default {
  name: 'DimensionLines',

  props: { src: String, texts: String },

  components: { shSizeText },

  data () {
    return {
      imageLoaded: false,
      fabricURL: 'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/5.3.1/fabric.js',
      scriptLoaded: false,
      fabric: undefined,
      canvas: undefined,
      points: {
        hide: false
      },
      eraser: {
        active: false,
        object: undefined
      },
      pen: {
        active: false
      },
      text: {
        active: false,
        object: undefined,
        move: false,
        edit: false
      },
      id: 0,
      objects: {
        paths: [],
        texts: [],
        active: undefined,
        sizesText: [],
        valuesText: [],
        currentIndex: -1,
        colorText: '',
        sizeText: '',
        degreesText: ''
      },
      configLines: {
        stroke: '#6BFA4D',
        strokeWidth: 1,
        strokeUniform: true,
        selectable: false,
        fill: '',
        shadow: {
          color: '#D95981',
          blur: 5,
          offsetX: 0,
          offsetY: 0,
          opacity: 1
        }
      },
      configCircle: {
        stroke: 'yellow',
        strokeWidth: 2,
        strokeUniform: true,
        selectable: false,
        fill: '',
        radius: 5,
        hasBorders: false,
        hasControls: false
      },
      creating: {
        path: false
      },
      p1: {
        x: 0,
        y: 0
      },
      p2: {
        x: 0,
        y: 0
      },
      repeatGlow: 10,
      showSizeText: false
    }
  },

  methods: {
    convertSizeFont (fontSize) {
      const normalwith = 330
      const width = this.$refs.$TextContainer.clientWidth

      return fontSize * width / normalwith
    },
    togglePoints () {
      this.points.hide = !this.points.hide

      this.objects.paths.forEach(path => {
        path.controlPoints.forEach(({ fabricPoint, curvePoint }) => {
          if (fabricPoint) fabricPoint.visible = !this.points.hide
          if (curvePoint) curvePoint.visible = !this.points.hide
        })
      })

      this.canvas.renderAll()
    },

    toggleEditSizeText () {
      this.text.edit = !this.text.edit
    },

    toggleMoveSizeText () {
      this.text.move = !this.text.move
    },

    openSizeText () {
      this.text.active = true
      this.showSizeText = true
    },

    closeSizeText () {
      this.text.active = false
      this.showSizeText = false
      this.objects.sizesText = []
      this.objects.valuesText = []
      this.objects.colorText = ''
      this.objects.sizeText = 10
      this.objects.degreesText = 0
      this.objects.currentIndex = -1
    },

    addSizes (data) {
      data.left = 5
      data.top = 5
      this.objects.texts.push(data)
    },

    updateSizes (data) {
      const { sizes, values, color, size, index, degrees } = data
      this.objects.texts[index].sizes = sizes
      this.objects.texts[index].values = values
      this.objects.texts[index].color = color
      this.objects.texts[index].size = size
      this.objects.texts[index].degrees = degrees
    },

    setTextSize (index) {
      if (this.eraser.active) {
        this.objects.texts.splice(index, 1)
        return
      }
      if (this.text.edit) {
        this.text.object = this.objects.texts[index]
        this.objects.sizesText = this.text.object.sizes
        this.objects.valuesText = this.text.object.values
        this.objects.colorText = this.text.object.color
        this.objects.sizeText = this.text.object.size
        this.objects.degreesText = this.text.object.degrees
        this.objects.currentIndex = index
        this.openSizeText()
        return
      }

      if (!this.text.move) return
      const width = this.$refs.$TextContainer.clientWidth
      const event = window.event
      this.text.object = this.objects.texts[index]
      this.text.object.x1 = event.x
      this.text.object.y1 = event.y
      this.text.object.leftInitial = width * this.text.object.left / 100
      this.text.object.topInitial = width * this.text.object.top / 100
    },

    clearTextSize () {
      this.text.object = undefined
    },

    moveText () {
      if (!this.text.object) return

      const width = this.$refs.$TextContainer.clientWidth

      const event = window.event
      const { x, y } = event
      const { x1, y1, leftInitial, topInitial } = this.text.object

      this.text.object.left = (leftInitial + x - x1) * 100 / width
      this.text.object.top = (topInitial + y - y1) * 100 / width
    },

    fitCanvasToImage () {
      const $Canvas = this.$refs.$Canvas
      const $Image = this.$refs.$Image

      $Canvas.width = $Image.width
      $Canvas.height = $Image.height

      if (!window.fabric) {
        const script = document.createElement('script')
        script.src = this.fabricURL
        script.async = true
        script.onload = () => {
          this.loadCanvas()
        }
        document.head.appendChild(script)
      }
    },

    loadCanvas () {
      this.scriptLoaded = true
      this.fabric = window.fabric
      this.canvas = new this.fabric.Canvas('$Canvas', {
        selection: false
      })

      this.canvas.on({
        'selection:created': this.onObjectSelected(event),
        'object:moving': (event) => this.onObjectMoving(event),
        'mouse:down': (event) => this.onMouseDown(event),
        'mouse:over': (event) => this.onMouseOver(event),
        'mouse:out': (event) => this.onMouseOut(event)
      })
    },

    onMouseOver (event) {
      const object = event.target

      if (object && object.customType === 'path' && this.eraser.active) {
        this.changeBorderPath(object, true)
        this.eraser.object = object
      }
    },

    changeBorderPath (path, selected) {
      path.set('strokeWidth', selected ? 3 : 1)
      this.canvas.renderAll()
      this.eraser.object = undefined
    },

    onMouseOut (event) {
      const object = event.target

      if (object && object.customType === 'path' && this.eraser.active) {
        this.changeBorderPath(object, false)
      }
    },

    onMouseDown (event) {
      if (this.canvas.getActiveObject()) return

      if (this.eraser.active && this.eraser.object) {
        const index = this.objects.paths.findIndex(path => path.id === this.eraser.object.id)

        if (index >= 0) {
          const pathFound = this.objects.paths[index]
          const { glow, controlPoints, path } = pathFound

          glow.forEach(g => this.canvas.remove(g))
          controlPoints.forEach(c => {
            this.canvas.remove(c.fabricPoint)
            this.canvas.remove(c.curvePoint)
          })
          this.canvas.remove(path)

          this.objects.paths.splice(index, 1)
        }

        this.canvas.renderAll()

        return
      }

      const { x, y } = this.getPositionPointer(event)

      if (this.creating.path) {
        if (!this.objects.active) {
          this.createPath(x, y)
        } else {
          this.addPointToPath(x, y)
        }
      }
    },

    onObjectSelected (event) {
    },

    onObjectMoving (event) {
      if (this.eraser.active) return

      const target = event.target
      const { index, type, path } = target

      if (type === 'control') {
        const x = target.left + this.configCircle.radius
        const y = target.top + this.configCircle.radius
        this.updateLine(path.path, index, x, y, 3, 4, path.glow)
      } else if (type === 'curve') {
        const x = target.left
        const y = target.top
        this.updateLine(path.path, index, x, y, 1, 2, path.glow)
      } else if (type === 'initial') {
        const x = target.left + this.configCircle.radius
        const y = target.top + this.configCircle.radius
        this.updateLine(path.path, index, x, y, 1, 2, path.glow)
      }

      // if (path) this.doStops(path)
    },

    updateLine (path, index, x, y, i1, i2, glow) {
      const line = path.path[index]

      line[i1] = x
      line[i2] = y

      this.updateDimensionsPath(path)

      if (!glow) return

      glow.forEach(path => {
        this.updateLine(path, index, x, y, i1, i2)
      })
    },

    togglePath () {
      if (!this.creating.path) {
        this.beginToCreatePath()
      } else {
        this.endToCreatePath()
      }
    },

    beginToCreatePath () {
      this.canvas.defaultCursor = 'url(https://sahet-cdn.b-cdn.net/img/cursors/pen.png) 0 20, auto'
      this.canvas.hoverCursor = 'url(https://sahet-cdn.b-cdn.net/img/cursors/pen.png) 0 20, auto'
      this.creating.path = true
      this.objects.active = undefined
      this.pen.active = true
    },

    endToCreatePath () {
      this.canvas.defaultCursor = 'default'
      this.canvas.hoverCursor = 'default'
      this.creating.path = true
      this.creating.path = false
      this.objects.active = undefined
      this.pen.active = false

      this.bringToFrontAllPointsAndMakeSelectable()

      this.canvas.renderAll()
    },

    bringToFrontAllPointsAndMakeSelectable () {
      this.objects.paths.forEach(path => {
        const { controlPoints } = path
        controlPoints.forEach(controlPoint => {
          const { fabricPoint, curvePoint } = controlPoint
          if (fabricPoint) {
            fabricPoint.selectable = true
            fabricPoint.bringToFront()
          }
          if (curvePoint) {
            curvePoint.selectable = true
            curvePoint.bringToFront()
          }
        })
      })
    },

    makeAllPointsSelectable (selectable) {
      this.objects.paths.forEach(path => {
        const { controlPoints } = path
        controlPoints.forEach(controlPoint => {
          const { fabricPoint, curvePoint } = controlPoint
          if (fabricPoint) {
            fabricPoint.selectable = selectable
          }
          if (curvePoint) {
            curvePoint.selectable = selectable
          }
        })
      })
    },

    createPath (x, y) {
      const initialPoint = ['M', x, y]

      this.setP1(x, y)

      const controlFabricPoint = this.createControlPoint(x, y)

      const fabricPath = new this.fabric.Path([initialPoint], this.configLines)
      fabricPath.customType = 'path'

      this.id = this.id + 1
      fabricPath.id = this.id

      const path = { id: this.id, path: fabricPath, glow: [], type: 'path', controlPoints: [{ point: initialPoint, fabricPoint: controlFabricPoint, type: 'initial' }] }

      controlFabricPoint.index = fabricPath.path.length - 1
      controlFabricPoint.type = 'initial'
      controlFabricPoint.path = path

      this.objects.paths.push(path)

      this.objects.active = path

      this.canvas.add(fabricPath)

      // this.doGlow(path)
    },

    addPointToPath (x, y) {
      this.setP2(x, y)

      const path = this.objects.active
      const fabricPath = path.path
      const pathData = fabricPath.path

      const controlPoint = this.getControlPoint()
      const curvePoint = ['Q', controlPoint.x, controlPoint.y, x, y]
      pathData.push(curvePoint)

      const controlFabricPoint = this.createControlPoint(x, y)
      controlFabricPoint.index = pathData.length - 1
      controlFabricPoint.type = 'control'
      controlFabricPoint.path = path

      const curveFabricPoint = this.createControlPoint(controlPoint.x, controlPoint.y)
      curveFabricPoint.index = pathData.length - 1
      curveFabricPoint.type = 'curve'
      curveFabricPoint.path = path

      this.objects.active.controlPoints.push({ point: curvePoint, fabricPoint: controlFabricPoint, curvePoint: curveFabricPoint, type: 'curve' })

      fabricPath.set({ path: pathData })
      this.updateDimensionsPath(fabricPath)

      this.setP1(x, y)
      // this.doStops()

      // this.doGlow(path)
    },

    doStops (path) {
      path = path || this.objects.active
      this.deleteStops(path)

      const { controlPoints } = path
      const length = controlPoints.length

      const p1 = controlPoints[0].point
      const p2 = controlPoints[1].point
      const p3 = controlPoints[length - 2].point
      const p4 = controlPoints[length - 1].point

      const angle1 = this.getAngle(p1[1], p1[2], p2[3], p2[4])

      const line1 = new this.fabric.Line([p1[1] - 10, p1[2], p1[1] + 10, p1[2]], {
        stroke: this.configLines.stroke,
        strokeWidth: this.configLines.strokeWidth,
        originX: 'center',
        originY: 'center'
      })

      line1.set({ angle: angle1.degrees - 90 })

      const i1 = p3[0] === 'M' ? 1 : 3
      const i2 = p3[0] === 'M' ? 2 : 4

      const angle2 = this.getAngle(p3[i1], p3[i2], p4[3], p4[4])

      const line2 = new this.fabric.Line([p4[3] - 10, p4[4], p4[3] + 10, p4[4]], {
        stroke: this.configLines.stroke,
        strokeWidth: this.configLines.strokeWidth,
        originX: 'center',
        originY: 'center'
      })

      line2.set({ angle: angle2.degrees - 90 })

      this.canvas.add(line1)
      this.canvas.add(line2)

      path.stops = [line1, line2]
    },

    deleteStops (path) {
      if (!path.stops) return

      path.stops.forEach(stop => {
        this.canvas.remove(stop)
      })
    },

    getAngle (x1, y1, x2, y2) {
      const dx = x1 - x2
      const dy = y1 - y2

      const radians = Math.atan2(dy, dx)
      const degrees = radians * (180 / Math.PI)

      return { radians, degrees }
    },

    doGlow (path) {
      this.deleteGlow(path)

      const { controlPoints } = path
      const points = controlPoints.map(controlPoint => controlPoint.point)

      for (let i = 0; i < this.repeatGlow; i++) {
        const glowPath = new this.fabric.Path(points, this.configLines)
        path.glow.push(glowPath)
        this.canvas.add(glowPath)
        glowPath.sendToBack()
      }
    },

    deleteGlow (path) {
      const { glow } = path

      glow.forEach(g => {
        this.canvas.remove(g)
      })

      path.glow = []
    },

    getPositionPointer (event) {
      const { x, y } = this.canvas.getPointer(event.e)
      return { x, y }
    },

    updateDimensionsPath (path) {
      const dims = path._calcDimensions()

      path.set({
        width: dims.width,
        height: dims.height,
        left: dims.left,
        top: dims.top,
        pathOffset: {
          x: dims.width / 2 + dims.left,
          y: dims.height / 2 + dims.top
        },
        dirty: true
      })

      path.setCoords()
      this.canvas.renderAll()
    },

    createControlPoint (x, y) {
      const { radius } = this.configCircle

      const controlPoint = new this.fabric.Circle({
        left: x - radius,
        top: y - radius,
        ...this.configCircle })

      this.canvas.add(controlPoint)

      return controlPoint
    },

    getControlPoint () {
      function getCenter (p1, p2) {
        return p1 > p2 ? (p1 - p2) / 2 + p2 : (p2 - p1) / 2 + p1
      }

      const p1 = this.p1
      const p2 = this.p2

      const x1 = p1.x
      const y1 = p1.y

      const x2 = p2.x
      const y2 = p2.y

      const x = getCenter(x1, x2)
      const y = getCenter(y1, y2)

      return { x, y }
    },

    setP1 (x, y) {
      this.p1 = { x, y }
    },

    setP2 (x, y) {
      this.p2 = { x, y }
    },

    toggleEraser () {
      this.eraser.active = !this.eraser.active

      if (this.eraser.active) {
        this.makeAllPointsSelectable(false)
        this.canvas.defaultCursor = 'url(https://sahet-cdn.b-cdn.net/img/cursors/eraser.png) 5 15, auto'
        this.canvas.hoverCursor = 'url(https://sahet-cdn.b-cdn.net/img/cursors/eraser.png) 5 15, auto'
      } else {
        this.makeAllPointsSelectable(true)
        this.canvas.defaultCursor = 'default'
        this.canvas.hoverCursor = 'default'
      }
    }
  },

  watch: {
    'objects.texts': {
      handler (newVal) {
        this.$emit('updateText', newVal)
      },
      deep: true
    },
    imageLoaded () {
      if (this.texts) {
        const arrayText = JSON.parse(this.texts)
        this.objects.texts = arrayText.length ? arrayText : []
      }
    },
    texts (newVal) {
      if (!newVal) newVal = '[]'
      const arrayText = JSON.parse(newVal)
      this.objects.texts = arrayText.length ? arrayText : []
    }
  }
}
</script>

<style lang="stylus">
@import '~@/stylus/functions.styl'

.container-dimensions
  margin 1em

.canvas-container
  display inline-flex
  position absolute !important
  top 0
  left 0

.image-dimension-container
  position relative
  display inline-flex
  margin-bottom 1em
  overflow hidden

.image-dimension
  width 100%

.container-pen, .container-eraser, .container-text
  display inline-flex
  align-items center
  gap .3em
  padding 0 .3em 0 .7em

.container-eraser
  padding .4em .7em

.container-icon-dimension
  width 2.5em
  height 2.5em
  display inline-flex
  justify-content center
  align-items center
  background-color rgba(0, 0, 0, .3)
  borderRadius(.5em)
  cursor pointer
  transition background .3s ease

.container-icon-dimension > img
  width 1.5em
  opacity 1

.container-icon-dimension.active
  background-color rgba(0, 0, 0, .8)

.input-color
  -webkit-appearance none
  -moz-appearance none
  appearance none
  width 3em
  height 3em
  border none
  cursor pointer
  background-color transparent
  width calc(3em + .27em)
  height calc(3em + .32em)
  margin-left .2em

.input-color::-webkit-color-swatch
  border-radius 50%
  border 1px solid rgba(0, 0, 0, .2)

.input-color::-moz-color-swatch
  border-radius 50%
  border 1px solid rgba(0, 0, 0, .2)

.input-color.radiance
  width calc(2.875em + .27em)
  height calc(2.875em + .36em)
  margin-left 0

.input-color.radiance::-webkit-color-swatch
  border-radius .8em
  border none

.input-color.radiance::-moz-color-swatch
  border-radius .8em
  border none

.toolbar
  display flex
  justify-content center
  align-items center
  gap .3em

.toolbar > div
  border 1px solid rgba(0, 0, 0, .3)
  border-bottom none
  border-top none

.size-dimension
  position absolute

.cursor-move
  cursor url(https://sahet-cdn.b-cdn.net/img/cursors/move.png) 8 8, auto

.size-item-dimension
  display flex
  gap 3px

.size-item-dimension > span:nth-child(1), .size-item-dimension > span:nth-child(3)
  flex-basis 2em
  flex-shrink 0

.size-item-dimension > span:nth-child(2)
  flex-basis 1em
  flex-shrink 0

.cursor-edit
  cursor url(https://sahet-cdn.b-cdn.net/img/cursors/edit.png) 8 8, auto

.cursor-eraser
  cursor url(https://sahet-cdn.b-cdn.net/img/cursors/eraser.png) 5 15, auto

.cursor-eraser:hover
  filter invert(.5)
</style>



// WEBPACK FOOTER //
// src/components/elements/DimensionLines.vue